import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { DIETS_AND_DIET_CATEGORIES_QUERY } from '../graphql/queries'
import { FETCH_DIETS_AND_DIET_CATEGORIES } from '../redux/action-types'
import { cleanupFetchDietsAndDietCategories } from '../redux/actions'

const useDietsAndDietCategoriesQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchDietsAndDietCategories)

  const { isLoading, error, initialData, latestEvent } = useSelector(
    store => store.diets.dietsAndDietCategories,
  )

  const refetch = useCallback(
    () =>
      apolloService.query(
        DIETS_AND_DIET_CATEGORIES_QUERY,
        {},
        dispatch,
        FETCH_DIETS_AND_DIET_CATEGORIES,
      ),

    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, initialData, latestEvent }
}

export default useDietsAndDietCategoriesQuery
